import {
  React,
  useState,
  useEffect,
  LoaderOverlay,
  withAuth,
  toast,
  connect,
  useDispatch,
  useSelector,
  useNavigate,
  MESSAGES,
} from "./../../common/helper/common-imports.component.js";
import {
  getConditionalRowStyles,
  customExpandableIcon,
  RowsPerPageSelector,
  SearchTable,
  DataTable,
  customDataTableStyles,
} from "./../../common/helper/table-imports.js";
import { agentsList } from "./../../../actions/agent-actions.js";
import ExpandedComponent from "./row-expand.component.js";
import Confirmation from "../../common/modals/confirmation.component.js";
import { AgentsService, ConfigService } from "../../../services/index.js";
import SelectSearch from "react-select-search";
import { agentsColoums } from "./agent-col.component.js";
import { pendingColumns } from "./pending-col.component.js";

import Transfer from "./transfer.component.js";
const AgentList = () => {
  const [selectedRows, setSelectedRows] = React.useState([]);
  const [loading, setLoading] = useState(false);
  const userData = useSelector((state) => state.authReducer);
  const [userType, setUserType] = React.useState(true);
  const [distributors, setDistributors] = useState([]);
  const [originalAgents, setOriginalAgents] = useState({
    active: [],
    inactive: [],
    rejected: [],
  });
  const [expanded, setExpanded] = useState({});
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [dataTableKey, setDataTableKey] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const dispatch = useDispatch();
  const [row, setRow] = useState({});
  const [modalShow, setModalShow] = React.useState(false);
  const [modalShowTransfer, setModalShowTransfer] = React.useState(false);
  const [selectedDistributor, setSelectedDistributor] = useState(null);
  const conditionalRowStyles = getConditionalRowStyles(expanded);
  // State to track whether the dropdown is visible
  const [isDropdownVisible, setDropdownVisible] = useState(false);
  const [tab, selectedTab] = useState("approved");
  const isRoleDistributor = userData?.user?.data?.role?.role_code === "DADMIN";
  // Function to toggle the dropdown visibility and button state
  const handleButtonClick = () => {
    setDropdownVisible((prevState) => {
      const newState = !prevState;

      if (newState) {
        // Dropdown is now visible, apply the filter
        filterDistributors("DISTRIBUTOR", tab);
      } else {
        // Dropdown is now hidden, reset the agents and distributor selection
        setAgents({
          active: originalAgents.active,
          inactive: originalAgents.inactive,
          rejected: originalAgents.rejected,
        });
        setSelectedDistributor(null);
      }

      return newState;
    });
  };
  const [agents, setAgents] = useState({
    active: [],
    inactive: [],
    rejected: [],
  });

  const transferAmount = (row) => {
    setModalShowTransfer(true);
    setRow({
      user_id: row.user_id,
      full_name: row.full_name,
      status: row.status,
      modalId: "transferAmount",
    });
  };

  const changeStatus = (row) => {
    setModalShow(true);
    setRow({
      user_id: row.user_id,
      status: row.status,
      modalId: "statusChangeAgent",
    });
  };

  const deleteConfirmation = () => {
    setLoading(true);
    AgentsService.deleteAgentData(row.user_id)
      .then((response) => {
        toast.success(MESSAGES.AGENT_DELETED);
        getAgentsList();
        setLoading(false);
        setModalShow(false);
      })
      .catch((error) => {
        const errorMessage = error.response.data;
        toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR);
        setLoading(false);
      });
  };

  const confirmTransfer = (data) => {
    console.log(data);
    setModalShowTransfer(false);
    getAgentsList();
  };

  const updateStatus = (data) => {
    if (row.modalId == "statusChangeAgent") {
      const suspended = [];
      const resume = [];
      if (row.status.toLowerCase() == "active") {
        suspended.push(row.user_id);
        suspendAgent(suspended);
      } else {
        resume.push(row.user_id);
        resumeAgent(resume);
      }
    } else if (row.modalId == "statusChangeAgentSuspend") {
      const suspended = [];
      for (var i = 0; i < selectedRows.length > 0; i++) {
        if (selectedRows[i].status_id.toLowerCase() == "a") {
          suspended.push(selectedRows[i].user_id);
        }
      }
      suspendAgent(suspended);
    } else if (row.modalId == "statusChangeAgentResume") {
      const resume = [];
      for (var i = 0; i < selectedRows.length > 0; i++) {
        if (selectedRows[i].status_id.toLowerCase() == "s") {
          resume.push(selectedRows[i].user_id);
        }
      }
      resumeAgent(resume);
    } else {
      deleteConfirmation();
    }
  };
  const suspendAgent = (suspended) => {
    setLoading(true);
    AgentsService.suspendAgent(suspended)
      .then((response) => {
        toast.success(MESSAGES.AGENT_SUSPENDED);
        getAgentsList();
        setLoading(false);
        setModalShow(false);
        setDataTableKey((prevKey) => prevKey + 1);
      })
      .catch((error) => {
        const errorMessage = error.response.data;
        toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR);
        setLoading(false);
      });
  };

  const deleteAgent = (row) => {
    setModalShow(true);
    setRow({
      user_id: row.user_id,
      status: row.status,
      modalId: "deleteAgent",
    });
  };

  const resumeAgent = (resume) => {
    setLoading(true);
    AgentsService.resumeAgent(resume)
      .then((response) => {
        toast.success(MESSAGES.AGENT_RESUME);
        getAgentsList();
        setLoading(false);
        setModalShow(false);
        setDataTableKey((prevKey) => prevKey + 1);
      })
      .catch((error) => {
        try {
          const errorMessage = error.response.data;
          toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR);
        } catch (e) {
          toast.error(MESSAGES.SERVER_ERROR);
        }

        setLoading(false);
      });
  };

  const approveAgent = (row) => {
    if (row.is_verification_pending == true) {
      toast.error(MESSAGES.AGENT_EMAIL_VERIFICATION);
      return;
    }
    navigate(`/approve-agent/${row.user_id}`);
  };
  const getAgentsList = (e) => {
    setLoading(true);
    dispatch(agentsList())
      .then((response) => {
        setAgents({
          active: response.data.Active,
          inactive: response.data.Pending,
          rejected: response.data.Rejected,
        });
        setOriginalAgents({
          active: response.data.Active,
          inactive: response.data.Pending,
          rejected: response.data.Rejected,
        });

        if (userData?.user?.data?.role?.role_code === "ADMIN") {
          getDistributors();
        }

        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };
  console.log(
    userData?.user?.data?.role?.role_code,
    "userData?.user?.data?.role?.role_code"
  );
  useEffect(() => {
    if (userData?.user?.data?.role?.role_code === "ADMIN") {
      setColumns((prevColumns) => {
        // Check if the column already exists to prevent duplicates
        if (prevColumns.some((col) => col.name === "Distributor")) {
          return prevColumns;
        }

        // Create the new column
        const newCol = {
          name: "Distributor",
          sortable: true,
          cell: (row) => (
            <div className="custom-cell-fullName">
              {row.customer_type == "OWNER" ? "SYSTEM" : row.customer_name}
            </div>
          ),
        };

        // Insert the new column at the second position
        return [
          prevColumns[0], // First column remains unchanged
          newCol, // Add new column as second
          ...prevColumns.slice(1), // Rest of the columns follow
        ];
      });

      setColumnsPending((prevColumns) => {
        // Check if the column already exists to prevent duplicates
        if (prevColumns.some((col) => col.name === "Distributor")) {
          return prevColumns;
        }

        // Create the new column
        const newCol = {
          name: "Distributor",
          sortable: true,
          cell: (row) => (
            <div className="custom-cell-fullName">
              {row.customer_type == "OWNER" ? "SYSTEM" : row.customer_name}
            </div>
          ),
        };

        // Insert the new column at the second position
        return [
          prevColumns[0], // First column remains unchanged
          newCol, // Add new column as second
          ...prevColumns.slice(1), // Rest of the columns follow
        ];
      });
    }
    setUserType(userData.user.data.role.role_code);

    getAgentsList();
    document.body.style.backgroundImage = "";
    document.body.style.backgroundColor = "#f0f6fa";

    return () => {
      document.body.style.backgroundColor = "";
    };
  }, []);
  const navigate = useNavigate();

  const handleRowExpand = (row, data) => {
    const newExpanded = { ...expanded };
    newExpanded[data.user_id] = !expanded[data.user_id];
    setExpanded(newExpanded);
  };

  const handleRowsPerPageChange = (value) => {
    setRowsPerPage(Number(value));
    setDataTableKey((prevKey) => prevKey + 1);
  };

  const paginationComponentOptions = {
    noRowsPerPage: true,
  };
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const escapeRegExp = (string) => {
    return string.replace(/[.*+\-?^${}()|[\]\\]/g, "\\$&");
  };
  const filteredData = (agents.active || []).filter((row) =>
    Object.values(row || {}).some((value) =>
      new RegExp(escapeRegExp(searchTerm), "i").test(value)
    )
  );

  const filteredInactiveData = (agents.inactive || []).filter((row) =>
    Object.values(row || {}).some((value) =>
      new RegExp(escapeRegExp(searchTerm), "i").test(value)
    )
  );

  const filteredRejectedData = (agents.rejected || []).filter((row) =>
    Object.values(row || {}).some((value) =>
      new RegExp(escapeRegExp(searchTerm), "i").test(value)
    )
  );

  const resetSearch = (tab) => {
    setRowsPerPage(25);
    selectedTab(tab);
    setSearchTerm("");
    setSelectedDistributor("");
    setAgents({
      active: originalAgents.active,
      inactive: originalAgents.inactive,
      rejected: originalAgents.rejected,
    });
  };

  const selectRows = React.useCallback((state) => {
    setSelectedRows(state.selectedRows);
  }, []);

  const suspendMultiple = () => {
    setModalShow(true);
    setRow({
      // user_id: row.user_id,
      status: "Suspend",
      modalId: "statusChangeAgentSuspend",
    });
  };

  const resumeMultiple = () => {
    setModalShow(true);
    setRow({
      // user_id: row.user_id,
      status: "Resume",
      modalId: "statusChangeAgentResume",
    });
  };
  const addNewAgent = (e) => {
    navigate("/add-agent");
  };

  const getDistributors = () => {
    setLoading(true);
    ConfigService.getDistributorDropDown()
      .then((response) => {
        const dis = response.data.data;
        const arr = [];
        for (var i = 0; i < dis.length; i++) {
          arr.push({
            name: dis[i].value,
            value: dis[i].key,
          });
        }
        setDistributors(arr);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };
  const filterAgents = (e) => {
    setSelectedDistributor(e);
    filterDistributors(e, tab);
  };

  const filterDistributors = (e, tab) => {
    let filteredData = [];

    if (tab === "approved") {
      filteredData = originalAgents.active.filter((agent) =>
        e === "DISTRIBUTOR"
          ? agent.customer_type === "DISTRIBUTOR"
          : agent.customer_id === e
      );
      setAgents({ ...agents, active: filteredData });
    } else if (tab === "pending") {
      filteredData = originalAgents.inactive.filter((agent) =>
        e === "DISTRIBUTOR"
          ? agent.customer_type === "DISTRIBUTOR"
          : agent.customer_id === e
      );
      setAgents({ ...agents, inactive: filteredData });
    } else if (tab === "rejected") {
      filteredData = originalAgents.rejected.filter((agent) =>
        e === "DISTRIBUTOR"
          ? agent.customer_type === "DISTRIBUTOR"
          : agent.customer_id === e
      );
      setAgents({ ...agents, rejected: filteredData });
    }
  };
  const [columns, setColumns] = useState(
    agentsColoums(
      expanded,
      transferAmount,
      userData,
      changeStatus,
      approveAgent,
      deleteAgent
    )
  );
  const [columnsPending, setColumnsPending] = useState(
    pendingColumns(expanded, changeStatus, approveAgent, deleteAgent)
  );

  useEffect(() => {
    if (
      filteredData?.length ||
      columnsPending.length ||
      filteredRejectedData.length
    ) {
      const element = document.getElementsByClassName("sc-bHCmUC");
      let childElement = "";
      if (columnsPending.length) {
        childElement = element.children;
      }
      if (filteredRejectedData.length) {
        childElement = element.children;
      }
      if (filteredData?.length) {
        childElement = element[0].children;
        console.log(childElement);
      }
      for (let i = 0; i < childElement?.length; i++) {
        const ele = childElement[i].id.split("-")[1];
        if (Number(ele) % 2 === 0) {
          childElement[i].classList.add("odd-transaction-table");
        } else {
          childElement[i].classList.add("even-transaction-table");
        }
      }
    }
  }, [filteredData, columnsPending, filteredRejectedData]);

  return (
    <div>
      <LoaderOverlay loading={loading} />

      <div className="container-fluid px-4" style={{ paddingBottom: "30px" }}>
        <h4
          className="mb-3 updatename updatename1 align-self-center text-color-theme"
          style={{ marginTop: 0, fontWeight: 700, fontSize: "22px" }}
        >
          Agents
        </h4>
        <div className="container" style={{ backgroundColor: "white" }}>
          <nav>
            <div
              className="nav nav-tabs flex justify-between"
              id="nav-tab"
              role="tablist"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <div className="flex" style={{ display: "flex" }}>
                <button
                  className="nav-link active tbbtn"
                  id="nav-home-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#nav-home"
                  type="button"
                  role="tab"
                  aria-controls="nav-home"
                  aria-selected="true"
                  onClick={() => resetSearch("approved")}
                >
                  Approved ({agents.active.length})
                </button>
                <button
                  className="nav-link tbbtn"
                  id="nav-profile-tab"
                  onClick={() => resetSearch("pending")}
                  data-bs-toggle="tab"
                  data-bs-target="#nav-profile"
                  type="button"
                  role="tab"
                  aria-controls="nav-profile"
                  aria-selected="false"
                >
                  Pending ({agents.inactive.length})
                </button>
                <button
                  className="nav-link tbbtn"
                  id="nav-contact-tab"
                  onClick={() => resetSearch("rejected")}
                  data-bs-toggle="tab"
                  data-bs-target="#nav-contact"
                  type="button"
                  role="tab"
                  aria-controls="nav-contact"
                  aria-selected="false"
                >
                  Rejected ({agents.rejected.length})
                </button>
              </div>

              {userType == "ADMIN" && (
                <div className="col-md-6 agentDistributor">
                  {isDropdownVisible && (
                    <div className="" style={{ textAlign: "left" }}>
                      <SelectSearch
                        search={true}
                        options={distributors}
                        name="customer_id"
                        value={selectedDistributor}
                        onChange={filterAgents}
                        placeholder="Select Distributors"
                      />
                      <span class="fa fa-angle-down errspan"></span>
                    </div>
                  )}
                  <a style={{ width: "auto", padding: "12px" }}>
                    <button
                      className={`btn ${
                        isDropdownVisible
                          ? "btn-bg-theme-Color text-light"
                          : "distributorButton"
                      }`}
                      onClick={handleButtonClick}
                    >
                      Distributors
                    </button>
                  </a>
                </div>
              )}
            </div>
          </nav>

          <div className="filterBtn">
            <SearchTable
              searchTerm={searchTerm}
              handleSearchChange={handleSearchChange}
            />

            {userType == "DADMIN" && (
              <div className="dt-buttons ui-buttonset">
                <a
                  className="dt-button ui-button ui-state-default ui-button-text-only btn btn-success ddfg"
                  tabIndex={0}
                  aria-controls="examplemgm"
                >
                  <span className="ui-button-text" onClick={addNewAgent}>
                    Add Agent
                  </span>
                </a>
              </div>
            )}
          </div>

          <RowsPerPageSelector
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleRowsPerPageChange}
          />

          <div
            className="tab-content"
            id="nav-tabContent"
            style={{ paddingTop: "15px" }}
          >
            <div
              className="tab-pane fade show active"
              id="nav-home"
              role="tabpanel"
              aria-labelledby="nav-home-tab"
              style={{ position: "relative" }}
            >
              <div className="multi">
                <a
                  className="nav-link dropdown-toggle news fell jhb"
                  id="navbarDropdown"
                  href="#"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  style={{
                    opacity: selectedRows.length > 0 ? 1 : "",
                    pointerEvents: selectedRows.length > 0 ? "auto" : "none",
                  }}
                >
                  <i className="fa fa-ellipsis-h" aria-hidden="true" />
                </a>
                <ul
                  className="dropdown-menu dropdown-menu-end mbv"
                  id="nvb"
                  aria-labelledby="navbarDropdown"
                  style={{}}
                >
                  <li onClick={suspendMultiple}>
                    <a
                      className="dropdown-item"
                      href="#!"
                      style={{ fontSize: "13px" }}
                    >
                      Suspend
                    </a>
                  </li>
                  <li onClick={resumeMultiple}>
                    <a
                      className="dropdown-item"
                      href="#!"
                      style={{ fontSize: "13px" }}
                    >
                      Activate
                    </a>
                  </li>
                </ul>
                <span className="DataTables_sort_icon css_right ui-icon ui-icon-triangle-1-n" />
              </div>

              <DataTable
                className={`agent-list ${
                  !isRoleDistributor
                    ? "ndadmin-agent-list"
                    : "dadmin-agent-list"
                }`}
                key={dataTableKey}
                columns={columns}
                data={filteredData}
                pagination
                // selectableRows
                // expandableRows
                // expandableRowsComponent={ExpandedComponent}
                // onRowExpandToggled={handleRowExpand}
                paginationComponentOptions={paginationComponentOptions}
                conditionalRowStyles={conditionalRowStyles}
                paginationPerPage={rowsPerPage}
                // expandableIcon={customExpandableIcon}
                // expandOnRowClicked = {true}
                onSelectedRowsChange={selectRows}
                customStyles={customDataTableStyles}
              />
            </div>
            <div
              className="tab-pane fade"
              id="nav-profile"
              role="tabpanel"
              aria-labelledby="nav-profile-tab"
            >
              <DataTable
                key={dataTableKey}
                columns={columnsPending}
                data={filteredInactiveData}
                pagination
                paginationComponentOptions={paginationComponentOptions}
                conditionalRowStyles={conditionalRowStyles}
                paginationPerPage={rowsPerPage}
                customStyles={customDataTableStyles}
              />
            </div>
            <div
              className="tab-pane fade"
              id="nav-contact"
              role="tabpanel"
              aria-labelledby="nav-contact-tab"
            >
              <DataTable
                key={dataTableKey}
                columns={columns}
                data={filteredRejectedData}
                pagination
                paginationComponentOptions={paginationComponentOptions}
                conditionalRowStyles={conditionalRowStyles}
                paginationPerPage={rowsPerPage}
                customStyles={customDataTableStyles}
              />
            </div>
          </div>
        </div>
      </div>
      <Confirmation
        show={modalShow}
        onHide={() => setModalShow(false)}
        onSave={(data) => updateStatus(data)}
        status={row.status}
        modalId={row.modalId}
      ></Confirmation>
      {modalShowTransfer && (
        <Transfer
          show={modalShowTransfer}
          onSave={() => confirmTransfer(false)}
          onHide={() => setModalShowTransfer(false)}
          rowData={row}
        />
      )}
    </div>
  );
};
function mapStateToProps(state) {
  const userData = state.authReducer.user;
  return { userData };
}
export default withAuth(connect(mapStateToProps)(AgentList));
